export const getSubscriptionTypeBadge = (type: string): { color: string; label: string } => {
  const badges: Record<string, { color: string; label: string }> = {
    dhcp_pool: { color: 'bg-blue-100 text-blue-700', label: 'DHCP Pool' },
    source_nat: { color: 'bg-green-100 text-green-700', label: 'Source NAT' },
    port_forwarding: { color: 'bg-purple-100 text-purple-700', label: 'Port Forwarding' },
  };
  return badges[type] || { color: 'bg-gray-100 text-gray-700', label: type };
};
